import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type { Club } from "./clubs.service";

export interface CareerEntry {
  id: number;
  playerId: number;
  clubId: number;
  fromYear: number | null;
  toYear: number | null;
  order: number;
  club: Pick<Club, "id" | "name" | "logoUrl" | "league">;
}

export interface CareerEntryListResponse {
  player: { id: number; name: string };
  entries: CareerEntry[];
}

export interface CreateCareerEntryRequest {
  clubId: number;
  fromYear?: number | null;
  toYear?: number | null;
  order?: number;
}

export type UpdateCareerEntryRequest = Partial<CreateCareerEntryRequest>;

export const careerEntryService = {
  list: async (playerId: number): Promise<CareerEntryListResponse> => {
    return apiClient.get(API_ENDPOINTS.PLAYERS.CAREER_LIST(playerId));
  },

  create: async (
    playerId: number,
    data: CreateCareerEntryRequest,
  ): Promise<CareerEntry> => {
    return apiClient.post(API_ENDPOINTS.PLAYERS.CAREER_CREATE(playerId), data);
  },

  update: async (
    playerId: number,
    entryId: number,
    data: UpdateCareerEntryRequest,
  ): Promise<CareerEntry> => {
    return apiClient.patch(
      API_ENDPOINTS.PLAYERS.CAREER_UPDATE(playerId, entryId),
      data,
    );
  },

  remove: async (
    playerId: number,
    entryId: number,
  ): Promise<{ message: string }> => {
    return apiClient.delete(API_ENDPOINTS.PLAYERS.CAREER_DELETE(playerId, entryId));
  },
};
